import { data_from_server_post } from '@/shared/http/client';
import { DEFAULT_CLIENT_ID } from '@/config/client';

/**
 * Fire-and-forget stamp of the Create-Task wizard step the user reached.
 *
 * Feeds the observability "User Journey Drop-off Funnel" (draft tasks by
 * wizard step); nothing in the product reads it back. Errors are swallowed
 * so telemetry can never block or toast inside the wizard.
 *
 * @param {string} usecaseId
 * @param {string} step  one of the `WizardStepper` step keys
 */
export function stampWizardStep(usecaseId, step) {
    if (!usecaseId || !step) return;
    data_from_server_post(
        'task-wizard-step',
        { client_id: DEFAULT_CLIENT_ID, llm_usecase_id: usecaseId, step },
        undefined,
        () => {}
    );
}
